import { Injectable } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { FileResponse, ImportType, ManualImportClient } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class ManualImportService {

  constructor(
    private manualImportClient: ManualImportClient,
    private toastService: ToastService
  ) { }

  public downloadTemplate(type: ImportType): Observable<FileResponse> {
    return this.manualImportClient.downloadTemplate(type).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.manual-import.messages.template-download-success-title',
          'i18n.domain.manual-import.messages.template-download-success-message');
      }),
      catchError(err => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => err);
      })
    );
  }
}
